import { render, staticRenderFns } from "./ViewToast.vue?vue&type=template&id=65005c5c&scoped=true&"
import script from "./ViewToast.vue?vue&type=script&lang=js&"
export * from "./ViewToast.vue?vue&type=script&lang=js&"
import style0 from "./ViewToast.vue?vue&type=style&index=0&id=65005c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65005c5c",
  null
  
)

component.options.__file = "ViewToast.vue"
export default component.exports